import { useAppSelector } from "../../app/hooks";
import { IdProps } from "../../types/Props.type";

export const Club = ({ id }: IdProps) => {
  const club = useAppSelector((state) =>
    state.api.clubs.find((club) => club.id === id),
  );
  return <>{club?.name}</>;
};
